/**
 * Возвращает функцию, которая должна вызываться при триггере экшна.
 * @param setIsActive Функция для изменения состояния "активности" экшна (в этом случае - дровер с маршрутом)
 */
export const getTriggerHandler = (setIsActive: (isActive: boolean) => void) => () => {
  setIsActive(true)
}
